export default __webpack_public_path__ + "static/media/benefits@2x.b32ae28e.png";